import React from 'react';
import {assetsBaseUrl} from "../services/calculationsApi";

function Usp() {


  return (
  <>
  <div className="ct-usp">
    <div class="ct-usp__list">
      <h2>Waarom De Hypotheker</h2>
      <ul>
        <li>
          <span>
            <img
            src={`${assetsBaseUrl}/assets/svg/check.svg`}
            alt=""
            />
          </span>
          Wij vergelijken meer dan 40 banken
        </li>
        <li>
          <span>
           <img
           src={`${assetsBaseUrl}/assets/svg/check.svg`}
           alt=""
           />
          </span>
          Met ruim 180 vestigingen zitten we altijd bij je in de buurt
        </li>
        <li>
          <span>
            <img
            src={`${assetsBaseUrl}/assets/svg/check.svg`}
            alt=""
            />
          </span>
          De eerste afspraak is altijd kosteloos
        </li>
      </ul>
    </div>

    <div class="ct-usp__reviews">
      <div class="ct-usp__reviews__payoff">
        <div class="ct-usp__reviews__payoff__score u-h1">9,7</div>
        <div class="ct-usp__reviews__payoff__text u-h3">Wat onze klanten van ons vinden</div>
      </div>
      <div>
        <div class="u-h5">31.121 beoordelingen</div>
      </div>
      <img
      class="ct-usp__reviews__logo"
      alt="Advieskeuze logo"
      src={`${assetsBaseUrl}/assets/images/logo-advies-keuze-horizontal.png`}
      />
    </div>
  </div>

</>
);
}

export default Usp;
